import React, { useState, useEffect, useRef } from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';

export default function UsdmHistory() {
  const [address, setAddress] = useState('');
  const [location, setLocation] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errMsg, setErrMsg] = useState('');
  const [iframeSource, setIframeSource] = useState(null);
  const inputRef = useRef(null);
  const API_KEY = process.env.REACT_APP_GEOAPIFY_API_KEY; 

  const handleSearch = (e) => {
    e.preventDefault();
    setIframeSource(null);
    if (!address) {
      setErrMsg('Please enter a location (city, state) or zip code in the box above')
    };
    setLoading(true);
    try {
      fetch("https://api.geoapify.com/v1/geocode/search?text=" + encodeURIComponent(address) + "&format=json&filter=countrycode:us&apiKey=" + API_KEY)
      .then(res => res.json())
      .then( (data) => {
        if (data.results && data.results.length > 0) {
          setErrMsg('')
          const result = data.results[0];
          setLocation(result.formatted);
          setIframeSource ("https://www.wrds.uwyo.edu/cgi-bin/getprism/usdmcell?"+result.lat+"E"+result.lon+"E5")
        } else {
          setErrMsg('No coordinates found for this address.');
        }
      });
    } catch (err) {
      setErrMsg('Error on location search: {err}');
    }
  };

  const handleIframeLoad = () => {
    setLoading(false); // Turns off loading when the MUI Box iframe finishes rendering
  };

  // position cursor in textfield
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [])

  return (
    <>
      <Typography variant="h6" component="h2" sx={{m: "0 0 0.5em"}} >
				US Drought Monitor Category History
      </Typography>

      <Box component="form" target="iframeTarget" onSubmit={handleSearch}>
        <Stack direction="row" spacing={1} alignItems="stretch">
          <TextField
            value={address}
            label="Location"
            placeholder="Enter city, state or zip code"
            size="small"
            inputRef={inputRef}
            onChange={(e) => setAddress(e.target.value)}
            sx={{ mr:2, width:300}}
          />
          <Button variant="outlined" size="small" type="submit">
            Search
          </Button>
        </Stack>
      </Box>

      {loading &&
        <Typography sx={{mt:2}}>
          Loading ...
        </Typography>
      }

      {errMsg &&
        <Typography color="error" sx={{mt:2}}>
          {errMsg}
        </Typography>
      }

      {iframeSource && 
        <>
          <Typography sx={{ fontWeight: 'bold', mt: 2}}>
            Drought Monitor History for {location}
          </Typography>
          <Box
            component="iframe"
            name="iframeTarget"
            onLoad={handleIframeLoad}
            src={iframeSource}
            title= {"External Content from " + iframeSource}
            sx={{
              width: '100%',
              height: '700px',
              border: 'none'
            }}
          />
        </>
      }
    </>
  );
}
